import React from 'react';
import 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import pendingImage from './pending_bank_transfer_illustration.png';
import Dialog from 'components/Dialog';
import { useTranslation } from 'react-i18next';
import { usePendingBankTransferModal } from './usePendingBankTransferModal';

export function PendingBankTransferModal() {
  const { isOpen, close } = usePendingBankTransferModal();
  const { t } = useTranslation(['common', 'userSettings']);

  return (
    <Dialog isOpen={isOpen} onClose={close}>
      <div tw="flex flex-col gap-8 items-center pb-8 pt-6 px-10">
        <img src={pendingImage} alt="" tw="w-[19rem]" />

        <div tw="flex flex-col gap-4 text-center w-full">
          <h1>
            {t(
              'userSettings:schoolSubscription.payByBankTransfer.pending.title',
            )}
          </h1>

          <div tw="text-neutral-moderate">
            <p tw="text-pretty">
              {t(
                'userSettings:schoolSubscription.payByBankTransfer.pending.description.line1',
              )}
            </p>
            <p tw="text-pretty">
              {t(
                'userSettings:schoolSubscription.payByBankTransfer.pending.description.line2',
              )}
            </p>
          </div>
        </div>

        <Button onClick={close} intent="primary" large>
          {t('common:buttons.close')}
        </Button>
      </div>
    </Dialog>
  );
}
